import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import api from "../../services/axios";
import CustomDropdown from "../CustomDropdown";

const days = [
  { value: "Select", label: "Select" },
  { value: "today", label: "Today" },
  { value: 7, label: "Last 7 Days" },
  { value: 30, label: "30 Days" },
  { value: 180, label: "6 Months" },
  { value: 365, label: "12 Months" },
  { value: "ALL", label: "ALL" },
];

// Helper: converts seconds to "MM:SS"
const secondsToMMSS = (totalSeconds) => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.floor(totalSeconds % 60);
  const mm = minutes.toString().padStart(2, "0");
  const ss = seconds.toString().padStart(2, "0");
  return `${mm}:${ss}`;
};

export default function UserCallAverageChart() {
  const [categories, setCategories] = useState([]);
  const [avgDurationsSec, setAvgDurationsSec] = useState([]);
  const [selectedDays, setSelectedDays] = useState("ALL");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.post("/getAllCallLogs", { filter: selectedDays });
        const logs = res.data?.data || [];

        const grouped = logs.reduce((acc, log) => {
          const agent = log.answered_agent_name || log.answered_agent || "";
          const duration = Number(log.duration || log.billsec) || 0;
          acc[agent] ??= { total: 0, count: 0 };
          acc[agent].total += duration;
          acc[agent].count += 1;
          return acc;
        }, {});

        const cats = Object.entries(grouped).map(([agent, { total, count }]) => agent);
        const avgSec = cats.map((agent) =>
          grouped[agent].count > 0
            ? grouped[agent].total / grouped[agent].count
            : 0
        );

        setCategories(cats);
        setAvgDurationsSec(avgSec);
      } catch (err) {
        console.error("Error fetching call logs:", err);
      }
    };

    fetchData();
  }, [selectedDays]);

  const handleChange = (val) => setSelectedDays(val);

  const chartOptions = {
    chart: { type: "column", backgroundColor: "transparent" },
    title: { text: null },
    xAxis: {
      categories,
      labels: { style: { fontSize: "12px", color: "#6B7280" } },
      lineWidth: 0,
    },
    yAxis: {
      title: { text: "Average Duration (MM:SS)" },
      labels: { style: { fontSize: "11px", color: "#6B7280" } },
      gridLineWidth: 0,
    },
    legend: { enabled: false },
    tooltip: {
      useHTML: true,
      borderWidth: 0,
      backgroundColor: "transparent",
      shadow: false,
      formatter: function () {
        const label = secondsToMMSS(this.y);
        return `
          <div style="
            position: relative;
            width:130px;
            background: white;
            padding:8px 14px;
            border-radius:12px;
            border:1px solid #ddd;
            text-align:center;
            filter: drop-shadow(0 44px 44px rgba(0,0,0,0.08));
            backdrop-filter: blur(1.5px);
            font-family: 'Plus Jakarta Sans', sans-serif;">
            <div style="font-size:12px; font-weight:500; color: ${this.color};">
              ${this.series.name}
            </div>
            <div style="font-size:13px; font-weight:700; color:#1b1b1b; line-height:22px;">
              ${label}
            </div>
            <div style="
              content: '';
              position: absolute;
              bottom: -8px;
              left: 50%;
              transform: translateX(-50%);
              width: 0;
              height: 0;
              border-left: 8px solid transparent;
              border-right: 8px solid transparent;
              border-top: 8px solid white;"></div>
          </div>`;
      },
    },
plotOptions: {
  column: {
    borderRadius: 10,       // applies to both top & bottom
    minPointLength: 10,    // ensures bottom rounding shows
    pointPadding: 0.2,
    borderWidth: 0,
    dataLabels: {
      enabled: true,
      formatter: function () {
        return secondsToMMSS(this.y);
      },
    },
  },
},

    series: [
      {
        name: "Avg Call Time",
        data: avgDurationsSec,
        colorByPoint: true,
        colors: ["#94E9B8","#FF0000", "#999999", "#000000", "#FF9800", "#8a8cd9"],
      },
    ],
    credits: { enabled: false },
    exporting: { enabled: false },
    lang: { noData: "No call activity detected in this time range." },
    noData: {
      style: { fontWeight: "bold", fontSize: "14px", color: "#999" },
    },
  };

  return (
    <div className="assisvia">
      <div className="assisvia-header d-flex justify-content-between">
        <h2 className="heatmap-title">User Call Average</h2>
        <div className="selectinput">
          <CustomDropdown
            options={days}
            placeholder="Select Days"
            onChange={handleChange}
            name="days"
            className="selectinput"
            value={selectedDays}
          />
        </div>
      </div>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
}
